define('modules/lp_integration/models/integration_emblue',['require','exports','module','backbone','env'],function(require, exports, module){
  "use strict";

  var Backbone = require("backbone"),
    config = require("env");

  module.exports = Backbone.Model.extend({
    defaults: {
      active: false,
      fields: {},
      apiKey: null,
      config: {},
    },
    url: function(){
      return [config.apiHost, "pages", this.pageId, "integration", "emblue"].join("/");
    },
    initialize: function(attrs,options){
      this.pageId = options.pageId;
    },
    toJSON: function(){
      return _.omit(module.exports.__super__.toJSON.apply(this), "id");
    },
    validate: function(attrs){
      var errors = [];

      if (_.isEmpty(attrs.apiKey)) {
        errors.push({attribute: "apiKey", message:"required"});
      }

      if (_.isEmpty(attrs.fields)) {
        errors.push({attribute: "fields", message:"required"});
      }

      if (errors.length > 0) {
        return errors;
      }
    }
  });
});

